import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/views/layout'
import Home from '@/views/layout/home'
import Appointment from '@/views/layout/appointment'
import User from '@/views/layout/user'
const Login = () => import('@/views/login')
const Register = () => import('@/views/register')
const Apt = () => import('@/views/apt')
const AptDetail = () => import('@/views/aptDetail')

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    // 只捕获重复导航 / 重定向类型
    if (err.name === 'NavigationDuplicated' || err.message.includes('Redirected when going')) {
      console.warn('Navigation warning:', err.message)
      return err
    }
    // 其他错误继续抛
    return Promise.reject(err)
  })
}

const router = new VueRouter({
  routes: [
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    { path: '/apt', component: Apt, props: true },
    { path: '/apt-detail/:id', component: AptDetail },
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        { path: 'home', component: Home },
        { path: 'appointment', component: Appointment, meta: { requiresAuth: true } },
        // { path: 'manager', component: Manager, meta: { requiresAuth: true } },
        { path: 'user', component: User, meta: { requiresAuth: true } }
      ]
    }
  ]
})

// 全局前置导航守卫
router.beforeEach((to, from, next) => {
  const token = store.getters.token
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (token) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

export default router
